
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.7778 0H2.22222C1 0 0 1 0 2.22222V17.7778C0 19 1 20 2.22222 20H17.7778C19 20 20 19 20 17.7778V2.22222C20 1 19 0 17.7778 0ZM6.66667 15.5556H4.44444V13.3333H6.66667V15.5556ZM6.66667 11.1111H4.44444V8.88889H6.66667V11.1111ZM6.66667 6.66667H4.44444V4.44444H6.66667V6.66667ZM15.5556 15.5556H7.77778V13.3333H15.5556V15.5556ZM15.5556 11.1111H7.77778V8.88889H15.5556V11.1111ZM15.5556 6.66667H7.77778V4.44444H15.5556V6.66667Z"}})])
          )
        }
      }
    